/**
 * Function that opens new tab
 * and hides the activeTab if found
 * 
 * @param {object|HTMLElement} e - click event or tab element
 */

function openTab(e) {
    const tab = e.target ? e.target : e;

    if (e.target) {
        e.preventDefault();
    }
 
    const tabContent = document.getElementById(tab.getAttribute('aria-controls').replace('#', ''));
  
    if (tabContent) {
        const activeTab = tab.parentNode.parentNode.querySelector('.tab--active');

        if (activeTab) {
            activeTab.classList.remove('tab--active');
            activeTab.setAttribute('aria-selected', false); 

            const activeTabContent = document.getElementById(activeTab.getAttribute('aria-controls').replace('#', ''));
            if (activeTabContent) {
                activeTabContent.classList.remove('tab__content--active');
            }
        }

        tab.classList.add('tab--active');
        tab.setAttribute('aria-selected', true);
        tabContent.classList.add('tab__content--active');
    }
}

function openTabByHashId() {
    if (window.location.hash.indexOf('tab') > -1) {
        const tabContent = document.getElementById(window.location.hash.replace('#', ''));
        if (tabContent) {
            const tab = document.getElementById(tabContent.getAttribute('aria-labelledby'));
            openTab(tab);
        }
    }
}


/**
* Initialise Tabs with this function
* Will only run if given selector elements are found in DOM
* 
* @param {string} selector - element selector string 
*/
export function setupTabs(selector = '[data-action="tabs"]') {
    const tabsContainer = document.body.querySelectorAll(selector);

    if (tabsContainer) {
        for (let i = 0; i < tabsContainer.length; i++) {
            const tabs = tabsContainer[i].querySelectorAll('[role="tab"]');
      
            for (let t = 0; t < tabs.length; t++) {
                tabs[t].addEventListener('click', openTab);
            }
        }
    }
    
    openTabByHashId();

    window.addEventListener('hashchange', openTabByHashId, false);
}
